import React from "react";
import { AlertTriangleIcon, CheckIcon } from "lucide-react";
import { CtaButton } from "../CtaButton";
import { images, toolkitItems } from "../../data/content";
export function Hero() {
  return <header className="bg-cream" data-id="element-168" data-mp="cvl79czvvsx9">
      <div className="bg-navy px-4 py-3 text-center" data-id="element-169" data-mp="cu9tqlgmz6sy">
        <p className="mx-auto flex max-w-4xl items-start justify-center gap-2 text-sm font-bold text-white sm:text-base" data-id="element-170" data-mp="hvh0ch71lzy1">
          <AlertTriangleIcon className="mt-0.5 h-5 w-5 shrink-0 text-sun" aria-hidden="true" data-id="element-171" data-mp="mszdkjs3f1bu" />
          <span data-id="element-172" data-mp="qukk7ne1ajdl">Organize Your Pediatric OT Sessions, Goals, Documentation & Progress Tracking — All in One Practical Planning System!</span>
        </p>
      </div>

      <div className="mx-auto max-w-6xl px-4 pb-14 pt-8 sm:pt-12 lg:grid lg:grid-cols-[1fr_1.05fr] lg:items-center lg:gap-12 lg:pb-20" data-id="element-173" data-mp="10lfglkkzuzcr">
        <div className="text-center lg:text-left" data-id="element-174" data-mp="15ll18gsujllc">
          <h1 className="font-display text-[2.75rem] font-bold leading-[1] text-navy sm:text-6xl lg:text-7xl" data-id="element-175" data-mp="15ip4uwwnd4z0">
            Pediatric OT <span className="text-teal" data-id="element-176" data-mp="9oc6yjnw7ngm">Planning System™</span>
          </h1>
          <p className="mx-auto mt-4 max-w-xl text-lg font-bold leading-snug text-ink-soft sm:text-xl lg:mx-0" data-id="element-177" data-mp="4optqa82e77t">
            A Practical Planning, Documentation & Progress-Tracking Toolkit for Pediatric Occupational Therapists
          </p>

          <img src={images.mockup} alt="Pediatric OT Planning System — 6 workbooks and 5 bonus packs" className="-mx-4 mt-6 w-[calc(100%+2rem)] max-w-none lg:hidden" data-id="element-178" data-mp="3ruh51nutz6n1" />

          <div className="mt-6 rounded-3xl bg-white p-5 text-left ring-1 ring-navy/10 sm:p-6 lg:mt-8" data-id="element-179" data-mp="ngipgceiq6j8">
            <p className="font-display text-lg font-bold uppercase tracking-wide text-navy" data-id="element-180" data-mp="imxz96j62gul">Your complete digital planning toolkit</p>
            <ul className="mt-4 grid gap-3 sm:grid-cols-2" data-id="element-181" data-mp="el2ufs211lc2">
              {toolkitItems.map(item => <li key={item} className="flex items-start gap-3 text-base font-bold text-navy" data-id="element-182" data-mp="16e3dxiddf33b">
                  <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-teal text-white" data-id="element-183" data-mp="30lxcg6nde4v4">
                    <CheckIcon className="h-4 w-4" strokeWidth={3} aria-hidden="true" data-id="element-184" data-mp="35la20z5mlq1e" />
                  </span>
                  {item}
                </li>)}
            </ul>
          </div>

          <div className="mt-7 flex flex-col items-center gap-1 lg:items-start" data-id="element-185" data-mp="2vu5lvw47rz4z">
            <p className="font-display text-base font-semibold uppercase tracking-wide text-ink-soft" data-id="element-186" data-mp="2huwjbz8xl3jh">Introductory price</p>
            <p className="font-display text-5xl font-bold text-navy sm:text-6xl" data-id="element-187" data-mp="2mvkackx5tkdp">
              Just <span className="text-cta" data-id="element-188" data-mp="27y1mrlw7xd7u">$27</span> <span className="text-2xl" data-id="element-189" data-mp="27z2uphhxtjlc">USD</span>
            </p>
          </div>

          <CtaButton id="first-cta" label="Yes! I want the Pediatric OT Planning System™" sub="One-time payment. Digital product. Delivery details provided at checkout." className="mt-6 lg:mx-0" data-id="element-190" data-mp="2cx4i2emec52m" />
        </div>

        <div className="hidden lg:block" data-id="element-191" data-mp="1vmh8ebe472jd">
          <img src={images.mockup} alt="Pediatric OT Planning System — 6 workbooks and 5 bonus packs" className="w-full" data-id="element-192" data-mp="1vnaagz24p3v6" />
        </div>
      </div>
    </header>;
}